document.addEventListener('DOMContentLoaded', () => {

  const swiper = new Swiper('.j-episode-swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      630: {
        slidesPerView: 2,
      },
      1440: {
        slidesPerView: 3,
      },
      1920: {
        slidesPerView: 4,
      },
    }
  });
});
